import { useCallback, useState } from "react";
import { queryKeys } from "../constants/constans";
import { useQuery, useQueryClient } from "react-query";
import { CommonStatus } from "constants/enum";
import _ from "lodash";

export default function useShowListStaff() {
  const queryClient = useQueryClient();
  const { data: showListStaff }: any = useQuery(
    queryKeys.showListStaff,
    () => queryClient.getQueryData(queryKeys.showListStaff),
    {
      initialData: CommonStatus.ACTIVE,
    }
  );

  const setShowListStaff = useCallback(
    () =>
      queryClient.setQueryData(
        queryKeys.showListStaff,
        showListStaff ? CommonStatus.INACTIVE : CommonStatus.ACTIVE
      ),
    [queryClient, showListStaff]
  );

  return {
    showListStaff: showListStaff,
    setShowListStaff,
  };
}
